'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [11088,61446];
var unicode = 'f005';
var svgPathData = ['M28 171.5l127.5 127.7-28.1 178.2 160.8-81.8 160.8 81.8-28.1-178.2 127.5-127.7-178.2-28.3-82-160.7-82 160.7-178.2 28.3z', 'M581.9 160.6l-143.9 144.1 31.7 201.2-181.5-92.3-181.5 92.3 31.7-201.2-143.9-144.1 201.1-32 92.6-181.4 92.6 181.4 201.1 32zM370.2 143.1l-82-160.7-82 160.7-178.2 28.3 127.5 127.7-28.1 178.2 160.8-81.8 160.8 81.8-28.1-178.2 127.5-127.7-178.2-28.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;